(function() {
  'use strict';

  angular
    .module('iqxCore')
    .controller('ReportsCtrl', ReportsCtrl)


  function ReportsCtrl($scope, $location, FormSvc) {
    // Controller for reports selection list
    FormSvc.setOptions($scope,{
        fetchAPI:'callresult/NetReports',
        multiRow:true
        })
        
    $scope.runReport=function(report) {
      if (report.ReportParams){
        $location.url('/reportparams/'+report.ReportSource+'?title='+encodeURIComponent(report.ReportTitle)+'&params='+encodeURIComponent(report.ReportParams))
      } else {  // No params - go straight to report
        $location.url('/report/'+report.ReportSource)
      }
    }
      
    $scope.fetch()
  
    }

})()